import {BrowserModule, HAMMER_LOADER} from '@angular/platform-browser';
import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {AppComponent} from './app.component';
import {MaterialModule} from './system/common/material.module';
import {AppRoutingModule} from './system/routing/app-routing.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {GridModule, PageService, SortService, FilterService, GroupService, EditService, ResizeService, ToolbarService, ExcelExportService, PdfExportService} from '@syncfusion/ej2-angular-grids';
import {AccumulationChartModule, ChartModule} from '@syncfusion/ej2-angular-charts';
import {DateRangePickerModule} from '@syncfusion/ej2-angular-calendars';
import {Interceptor} from './system/interceptor/interceptor.component';
import {NavigationComponent} from './main/navigation/navigation.component';
import {HomeComponent} from './main/home/home.component';
import {AdministrationComponent} from './modules/administration/administration.component';
import {TransportComponent} from './modules/transport/transport.component';
import {TransportTaskComponent} from './modules/transport/transport-task/transport-task.component';
import {StateComponent} from './modules/state/state.component';
import {LoginComponent} from './logins/login/login.component';
import {EsaloginComponent} from './logins/esalogin/esalogin.component';
import {HstloginComponent} from './logins/hstlogin/hstlogin.component';
import {AgvsloginComponent} from './logins/agvslogin/agvslogin.component';
import {WheelnewsComponent} from './modules/wheelnews/wheelnews.component';
import {AirportparkingComponent} from './modules/airportparking/airportparking.component';
import {FooterComponent} from './main/footer/footer.component';
import {DamagereportComponent} from './modules/transport/damagereport/damagereport.component';
import {ModuleComponent} from './unit/module/module.component';
import {NewsComponent} from './main/news/news.component';
import {ProgressComponent} from './unit/progress/progress.component';
import {UsermanagementComponent} from './modules/administration/usermanagement/usermanagement.component';
import {NewsElementComponent} from './unit/news-element/news-element.component';
import {ScrollToTopComponent} from './unit/scroll-to-top/scroll-to-top.component';
import {WheelnewsOrderviewComponent} from './modules/wheelnews/wheelnews-orderview/wheelnews-orderview.component';
import {WheelnewsTaskComponent} from './modules/wheelnews/wheelnews-task/wheelnews-task.component';
import {LogosWithLinkComponent} from './unit/logos-with-link/logos-with-link.component';
import {MailServiceComponent} from './modules/administration/mail-service/mail-service.component';
import {SideNavigationComponent} from './unit/side-navigation/side-navigation.component';
import {DamageAdministrationComponent} from './modules/damage-administration/damage-administration.component';
import {DamageAdministrationCoreDataComponent} from './modules/damage-administration/damage-administration-core-data/damage-administration-core-data.component';
import {DamageAdministrationRecordComponent} from './modules/damage-administration/damage-administration-record/damage-administration-record.component';
import {DamageAdministrationOverviewComponent} from './modules/damage-administration/damage-administration-overview/damage-administration-overview.component';
import {DamageAdministrationEvaluationComponent} from './modules/damage-administration/damage-administration-evaluation/damage-administration-evaluation.component';
import {DamageAdministrationLogsComponent} from './modules/damage-administration/damage-administration-logs/damage-administration-logs.component';
import {DamagereportsComponent} from './modules/damage-administration/damagereports/damagereports.component';
import {ChangePasswordComponent} from './main/change-password/change-password.component';
import {MaintenanceComponent} from './unit/maintenance/maintenance.component';
import {TrackingComponent} from './main/tracking/tracking.component';
import {DndDirective} from './modules/transport/damagereport/dnd.directive';
import {ThreeDigitDecimalNumberDirectiveDirective} from './unit/directives/three-digit-decimal-number-directive.directive';
import {DigitIntegerDirectiveDirective} from './unit/directives/digit-integer-directive.directive';
import {ApiTokenComponent} from './modules/administration/api-token/api-token.component';
import {NgxSpinnerModule} from 'ngx-spinner';
import {QuillModule } from 'ngx-quill';
import {SpinnerInterceptor} from './system/interceptor/spinner.interceptor';
import {LogosWithLinkForDarkmodeComponent} from './unit/logos-with-link-for-darkmode/logos-with-link-for-darkmode.component';
import {LogisticsComponent} from './modules/logistics/logistics.component';
import {LogisticsTaskComponent} from './modules/logistics/logistics-task/logistics-task.component';
import {HomedeliveryTaskComponent} from './modules/transport/homdelivery-task/homedelivery-task.component';
import {ExternalStatePipe} from './pipes/externalState.pipe';
import {InitialsPipe} from './pipes/initials.pipe';
import {SafeHtmlPipe} from './pipes/safeHtml.pipe';
import {DamageCase} from './modules/transport/damage-case/damage-case.component';
import {DamageCaseRecord} from './modules/transport/damage-case/damage-case-record/damage-case-record.component';
import {DamageCaseOpen} from './modules/transport/damage-case/damage-case-open/damage-case-open.component';
import {DamageCaseClosed} from './modules/transport/damage-case/damage-case-closed/damage-case-closed.component';
import {DamageAdministrationCase} from './modules/damage-administration/damage-administration-case/damage-administration-case.component';
import {DamageAdministrationCaseOverview} from './modules/damage-administration/damage-administration-case-overview/damage-administration-case-overview.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    TransportComponent,
    TransportTaskComponent,
    StateComponent,
    LoginComponent,
    EsaloginComponent,
    HstloginComponent,
    AgvsloginComponent,
    WheelnewsComponent,
    AirportparkingComponent,
    NavigationComponent,
    AdministrationComponent,
    FooterComponent,
    DamagereportComponent,
    ModuleComponent,
    NewsComponent,
    ProgressComponent,
    UsermanagementComponent,
    NewsElementComponent,
    ScrollToTopComponent,
    WheelnewsOrderviewComponent,
    WheelnewsTaskComponent,
    LogosWithLinkComponent,
    MailServiceComponent,
    SideNavigationComponent,
    DamageAdministrationComponent,
    DamageAdministrationCoreDataComponent,
    DamageAdministrationRecordComponent,
    DamageAdministrationOverviewComponent,
    DamageAdministrationEvaluationComponent,
    DamageAdministrationLogsComponent,
    DamagereportsComponent,
    ChangePasswordComponent,
    MaintenanceComponent,
    DndDirective,
    ThreeDigitDecimalNumberDirectiveDirective,
    DigitIntegerDirectiveDirective,
    ApiTokenComponent,
    TrackingComponent,
    LogosWithLinkForDarkmodeComponent,
    LogisticsComponent,
    LogisticsTaskComponent,
    HomedeliveryTaskComponent,
    ExternalStatePipe,
    InitialsPipe,
    SafeHtmlPipe,
    DamageCase,
    DamageCaseRecord,
    DamageCaseOpen,
    DamageCaseClosed,
    DamageAdministrationCase,
    DamageAdministrationCaseOverview
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    BrowserAnimationsModule,
    FormsModule,
    GridModule,
    DateRangePickerModule,
    HttpClientModule,
    ReactiveFormsModule,
    ChartModule,
    AccumulationChartModule,
    NgxSpinnerModule,
    QuillModule.forRoot({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }],
          [{ indent: '-1' }, { indent: '+1' }],
          [{ direction: 'rtl' }],
          [{ align: [] }],
          ['blockquote', 'code-block'],
          [{ color: [] }, { background: [] }], 
          ['clean']
        ]
      },
      theme: 'snow'
    })
  ],
  providers: [
    {provide: HAMMER_LOADER, useValue: () => new Promise(() => {})},
    {provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true},
    PageService,
    SortService,
    FilterService,
    GroupService,
    EditService,
    ResizeService,
    ToolbarService,
    ExcelExportService,
    PdfExportService,
    ],
  bootstrap: [AppComponent],
  schemas: [
    NO_ERRORS_SCHEMA]
})
export class AppModule {}
